import { Fragment, type MouseEvent, type ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface BreadcrumbItem {
  label: ReactNode;
  href?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export interface BreadcrumbProps {
  items: readonly BreadcrumbItem[];
  className?: string;
  separator?: ReactNode;
}

export function Breadcrumb({ items, className, separator = '→' }: BreadcrumbProps) {
  return (
    <nav
      aria-label="breadcrumb"
      className={cn(
        'phx-breadcrumb gap-phx-3 text-phx-sm text-phx-text-muted inline-flex items-center',
        className
      )}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={index}>
            {index > 0 ? (
              <span aria-hidden className="phx-breadcrumb-sep text-phx-text-faint">
                {separator}
              </span>
            ) : null}
            {item.href || item.onClick ? (
              <a
                href={item.href ?? '#'}
                onClick={item.onClick}
                className={cn(
                  'phx-breadcrumb-link text-phx-text-muted hover:text-phx-link hover:underline',
                  isLast && 'text-phx-text font-medium'
                )}
              >
                {item.label}
              </a>
            ) : (
              <span
                className={cn(
                  'phx-breadcrumb-current',
                  isLast ? 'text-phx-text font-medium' : 'text-phx-text-muted'
                )}
              >
                {item.label}
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
